const SENTRY_LOCALHOST = process.env.VUE_APP_TRACING_ORIGIN_LOCALHOST;
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
const SENTRY_QAS_TRIPS = process.env.VUE_APP_TRACING_ORIGIN_QAS_TRIPS;
const SENTRY_DEV_TRIPS = process.env.VUE_APP_TRACING_ORIGIN_DEV_TRIPS;
const SENTRY_REGEX = process.env.VUE_APP_TRACING_ORIGIN_REGEX;
export {
    SENTRY_DSN,
    SENTRY_LOCALHOST,
    SENTRY_QAS_TRIPS,
    SENTRY_DEV_TRIPS,
    SENTRY_REGEX
};
